import {bymoTemplateMetadataFactoryCreate} from "../../../doppe-sdk";


export namespace BymoTemplateActionInLandingPagePreview {

    export interface TemplateProps {

    }
}

const initialValues = {};

export const BymoTemplateActionInLandingPagePreviewMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateActionInLandingPagePreview.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: bymoPagePRops => {
        return {
            ...initialValues,
            ...bymoPagePRops
        }
    },
    templatePropsMetadata: {},
    features: [
        'hasActions', 'hasActionButton' , 'hasProfileContent' ,'hasCustomTextualContent'
    ]
})